// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3PLBE","disabled":"FileBtn_disabled__12uj1","warn":"FileBtn_warn__3yrSl","fade":"FileBtn_fade__13-4T"};